import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-printables', 'BrandPrintables', [["path",{"d":"M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5l0 7","key":"svg-0"}]]);